export default async ({ store, route }) => {
  const { groupID } = route.query;
  if (!store.state.group.currentGroup.id && groupID) {
    await store.dispatch('group/getGroup', groupID);
  }
};
